import { render, staticRenderFns } from "./createTenant.vue?vue&type=template&id=485afbee&scoped=true"
import script from "./createTenant.vue?vue&type=script&lang=js"
export * from "./createTenant.vue?vue&type=script&lang=js"
import style0 from "./createTenant.vue?vue&type=style&index=0&id=485afbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485afbee",
  null
  
)

export default component.exports